import script from "./KnowMore.vue?vue&type=script&setup=true&lang=js"
export * from "./KnowMore.vue?vue&type=script&setup=true&lang=js"

import "./KnowMore.vue?vue&type=style&index=0&id=3543d47b&lang=postcss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3543d47b"]])

export default __exports__